<template>
    <div class="jd-slogin ta-center bg-white">
        <h3>玄商鉴定平台，便捷鉴定！</h3>
        <k-row>
            <k-col span="8">
                <span class="jd-icon jd-icon--jianding"></span> 专业权威
            </k-col>
            <k-col span="8">
                <span class="jd-icon jd-icon--baozhen"></span> 足不出户
            </k-col>
            <k-col span="8">
                <span class="jd-icon jd-icon--tuihuo"></span> 快速鉴宝
            </k-col>
        </k-row>
    </div>
</template>

<script>
    export default {
        name: "home-slogin"
    }
</script>

<style scoped>

</style>